module.exports = "/images/dense-fog@3x.png?3d95dacde90566cac1166d508e5ba8ac";